export default __webpack_public_path__ + "static/media/Cockpit-HD.17b9a9c8.jpg";